import React from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";

export default function SiteShell({ children, showFooter = true }) {
    const { pathname } = useLocation();
    return (
        <div className="relative min-h-screen overflow-x-hidden">
            <Header />
            <main key={pathname} className="relative page-fade">{children}</main>
            {showFooter && <Footer />}
        </div>
    );
}
